/**
 * @generated SignedSource<<48a26b732d91433e90af7cd24d903ca9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SyntheticActionItemGroupsListMoveMultipleItemMutation$variables = {
  noteBlockIds: ReadonlyArray<string>;
  orderInsertedAfter?: string | null;
  orderInsertedBefore?: string | null;
};
export type SyntheticActionItemGroupsListMoveMultipleItemMutation$data = {
  readonly moveActionItems: {
    readonly updatedBlocks: ReadonlyArray<{
      readonly id: string;
      readonly userOrder: string;
    }>;
  } | null;
};
export type SyntheticActionItemGroupsListMoveMultipleItemMutation$rawResponse = {
  readonly moveActionItems: {
    readonly updatedBlocks: ReadonlyArray<{
      readonly id: string;
      readonly userOrder: string;
    }>;
  } | null;
};
export type SyntheticActionItemGroupsListMoveMultipleItemMutation = {
  rawResponse: SyntheticActionItemGroupsListMoveMultipleItemMutation$rawResponse;
  response: SyntheticActionItemGroupsListMoveMultipleItemMutation$data;
  variables: SyntheticActionItemGroupsListMoveMultipleItemMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noteBlockIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderInsertedAfter"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderInsertedBefore"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "noteBlockIds",
        "variableName": "noteBlockIds"
      },
      {
        "kind": "Variable",
        "name": "orderInsertedAfter",
        "variableName": "orderInsertedAfter"
      },
      {
        "kind": "Variable",
        "name": "orderInsertedBefore",
        "variableName": "orderInsertedBefore"
      }
    ],
    "concreteType": "MoveActionItems",
    "kind": "LinkedField",
    "name": "moveActionItems",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NoteBlock",
        "kind": "LinkedField",
        "name": "updatedBlocks",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userOrder",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SyntheticActionItemGroupsListMoveMultipleItemMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "SyntheticActionItemGroupsListMoveMultipleItemMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "1366e186d91b1f92b526663149d5045f",
    "id": null,
    "metadata": {},
    "name": "SyntheticActionItemGroupsListMoveMultipleItemMutation",
    "operationKind": "mutation",
    "text": "mutation SyntheticActionItemGroupsListMoveMultipleItemMutation(\n  $noteBlockIds: [ID!]!\n  $orderInsertedBefore: String\n  $orderInsertedAfter: String\n) {\n  moveActionItems(noteBlockIds: $noteBlockIds, orderInsertedBefore: $orderInsertedBefore, orderInsertedAfter: $orderInsertedAfter) {\n    updatedBlocks {\n      id\n      userOrder\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e0d9d71d66b83e80bbb13b779bc71deb";

export default node;
